
import React, { useEffect, useRef, useState, useContext } from 'react';
// import FocusLock from 'react-focus-lock';
import { VideoContext } from '../../context/VideoContext';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import CustomScrollPanel from '../CustomScrollPanel';
import CloseButton from '../CloseButton';
gsap.registerPlugin(ScrollTrigger);

const DeepDive = React.forwardRef(({ onClose, children, id }, ref) => {
  
  const {setCurrentOverlay, currentDeepDiveIndex, setCurrentDeepDiveIndex} = useContext(VideoContext);
  const [hasBuilt, setHasBuilt] = useState(false);
  const vignetteRef = useRef();
  const contentRef = useRef();

  const clickOnClose = () => {
    onClose();
    contentRef.current.scrollTop = 0;
    setTimeout(() => {
      setCurrentOverlay(null);
      setCurrentDeepDiveIndex(null);
    }, 150);
    
  };

  useEffect(() => {

    if (!hasBuilt) {

      contentRef.current.querySelectorAll('.partial-container').forEach((el, index) => {
        
        ScrollTrigger.create({
          trigger: el,
          start: `${index === 0 ? 'top+=50px' : 'top-=50px'}`,
          end: "bottom-=50px",
          pinSpacing: false,
          scroller: contentRef.current,
          onEnter: () => {
            setCurrentOverlay(`deepdive_${id}_${index}`);
          },
          onLeave: () => {
            setCurrentOverlay(null);
          },
          onLeaveBack: () => {
            setCurrentOverlay(`deepdive_${id}_${index}`);
          },
        });
      });

      setHasBuilt(true);
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef, id]);

  return (
    <>
      <div ref={ref} className={`fixed z-[10000] inset-0 pointer-events-all ${(currentDeepDiveIndex === id) ? "visible" : "invisible"}`}>
        
        <div ref={vignetteRef} className={`vignette fixed top-0 left-0 w-full h-full shadow-deepdive-bg backdrop-blur-md `}></div>
        
        <div className={`flex min-h-full p-4 text-center items-center justify-center h-screen lg:h-auto`}>

          <div className="relative w-full h-[calc(100%-70px)] lg:w-4/5 aspect-video flex justify-center items-center bg-black bg-opacity-80 shadow-deepdive pointer-events-auto">

            <span className="corner w-[24.875px] h-[24.875px]  translate-y-[-1px] translate-x-[-1px] TL absolute bg-[url('./img/corner.svg')] -top-[4px] -left-[4px]"></span>
            <span className="corner w-[24.875px] h-[24.875px] translate-y-[-2px] TR absolute bg-[url('./img/corner.svg')] -top-[4px] -right-[4px] rotate-90"></span>
            <span className="corner  w-[24.875px] h-[24.875px] translate-y-[2px] BL absolute bg-[url('./img/corner.svg')] -bottom-[3px] -right-[3px] rotate-180"></span>
            <span className="corner w-[24.875px] h-[24.875px] translate-y-[1px] translate-x-[1px] BR absolute bg-[url('./img/corner.svg')] -bottom-[4px] -left-[6px] -rotate-90"></span>

            <button onClick={clickOnClose} className="absolute z-10 right-[-22px] top-[-22px] cursor-pointer">
              <CloseButton />
            </button>

            <CustomScrollPanel ref={contentRef} id={id}>
              {children}
            </CustomScrollPanel>

          </div>

        </div>
      </div>
    </>
  );
});

export default DeepDive;